import React from 'react';
import { inject, observer } from 'mobx-react';
import H5AvatarList from './h5';
import PCAvatarList from './pc';
import type { AppStore } from '@stores/app/store';
import type { SiteStore } from '@stores/site/store';
import type { UserAction } from '@stores/user/action';

interface AvatarListProps {
    app?: AppStore;
    site?: SiteStore;
    user?: UserAction;
    size?: any  // 头像尺寸
    userList: any   // 用户列表
    userCount?: any  // 显示的用户数量，默认3个
}

@inject('app', 'site', 'user')
@observer
class AvatarList extends React.Component<AvatarListProps> {
    componentDidMount() {
        // 可以在这里添加初始化逻辑
        // console.log('组件组件');
    }

    render() {
        const { site, app, userList, ...props } = this.props;
        const platform = app?.platform || 'h5';
        if (platform === 'pc') {
            return <PCAvatarList {...props} userList={userList}/>;
        } else {
            return <H5AvatarList {...props} userList={userList} />;
        }
        
        
    }
}

export default AvatarList;